import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { DatePicker, LocaleProvider } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import App from './App.vue'
import router from './router'
import Print from 'vue-print-nb'
import './bus'
import 'bootstrap'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { TablePlugin, PaginationPlugin, FormRadioPlugin } from 'bootstrap-vue'
import { faSignInAlt, faSignOutAlt, faListUl, faTasks, faUserCog,
  faEdit, faUserEdit, faUsersCog, faUserTimes, faUsers, faUserSlash,
  faAngleDoubleUp, faMinus, faPlus, faUserGraduate, faUserTie,
  faTimes, faFileExport, faPrint, faSearch, faEnvelope, faLevelDownAlt,
  faUser, faExclamationTriangle, faCheckCircle, faShoppingCart, faUserShield,
  faChevronCircleDown
} from '@fortawesome/free-solid-svg-icons'
import VueBarcode from '@xkeshi/vue-barcode'
import vButton from '@/components/Features/Button'

library.add(faSignInAlt, faSignOutAlt, faListUl, faTasks, faUserCog,
  faEdit, faUserEdit, faUsersCog, faUserTimes, faUsers, faUserSlash,
  faAngleDoubleUp, faMinus, faPlus, faUserGraduate, faUserTie,
  faTimes, faFileExport, faPrint, faSearch, faEnvelope, faLevelDownAlt,
  faUser, faExclamationTriangle, faCheckCircle, faShoppingCart, faUserShield,
  faChevronCircleDown
)

Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component(VueBarcode.name, VueBarcode)
Vue.component('v-button', vButton) // 元件-按鈕
Vue.use(PaginationPlugin)
Vue.use(VueAxios, axios)
Vue.use(FormRadioPlugin)
Vue.use(LocaleProvider)
Vue.use(TablePlugin)
Vue.use(DatePicker)
Vue.use(Print)

axios.defaults.withCredentials = true
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) { // 判斷路徑有無需要驗證
    const AIdentity = JSON.parse(localStorage.getItem('A_Identity')) // localStorage取Token
    const AdIdentity = JSON.parse(sessionStorage.getItem('A_Identity')) // localStorage取Token
    if (AIdentity) {
      if (AIdentity.Token) { // 判斷有無Token
        next()
      } else {
        next({
          path: '/news'
        })
      }
    } else {
      if (AdIdentity) {
        if (AdIdentity.Token) { // 判斷有無Token
          next()
        } else {
          next({
            path: '/Admin/login'
          })
        }
      } else {
        next({
          path: '/news'
        })
      }
    }
  } else {
    next()
  }
})
